import { z } from 'zod';
import { VerificationType } from './verification-type.js';
export const backupCodeVerificationRecordDataGuard = z.object({
    id: z.string(),
    type: z.literal(VerificationType.BackupCode),
    userId: z.string(),
    code: z.string().optional(),
    backupCodes: z.string().array().optional(),
});
